import styled from "styled-components";
import CurrencyInput from "../CurrencyInput";
import Flex from "../Flex";
import NbuLogo from '../../svg/nbu.png'
import Uah from '../../svg/UAH.svg'
import Eur from '../../svg/EUR.svg'
import Usd from '../../svg/USD.svg'
import Pln from '../../svg/PLN.svg'
import Gbp from '../../svg/GBP.svg'
import { useEffect, useState } from "react";
import Button from "../Button/Button";
import { NBU_API } from "../../config";
import { sendRequest } from "../../helpers";


const MainDeskContainer = styled.div`
display: flex;
justify-content:center;
@media ${props => props.theme.media.phone}{
    padding-bottom: 100px;
 }
`
const MainDeskWrapper = styled.div`
margin-top: 150px;
display:flex;
justify-content: center;
align-item:  center;
flex-direction: column;
@media ${props => props.theme.media.smallScreen}{
    margin-top: 150px;
}
@media ${props => props.theme.media.tablet}{
    margin-top: 100px;
} 
@media ${props => props.theme.media.phone}{
    margin-top: 50px;
 }
`
const NbuLogoStyled = styled.img`
width: 20px;
hight: auto;
margin-right: 4px;
`
const TitleStyled = styled.h2`
color: #fff;

`


const MainDesk = () =>{



const [currencies, setCurrencies ] = useState([])
const [baseCurrency,setBaseCurrency] = useState('UAH')
const [amount, setAmount] = useState(null)
const [targetCurrency, setTargetCurrency] = useState('USD');
const [result,setResult] = useState(0)
const [flagBase,setFlagBase] = useState({ flag: Uah, symbol: '₴'})
const [flagTarget,setFlagTarget] = useState({ flag: Usd, symbol: '$'})

useEffect(()=>{
    sendRequest(NBU_API)
    .then((data) =>{
        const currenciesData = data.filter(currency => ['USD', 'PLN', 'GBP', 'EUR'].includes(currency.cc))
        setCurrencies(currenciesData)
       })
    
},[])

const getAmount = (e)=>{
    setAmount(e.target.value)
}
const getBaseCurrency = (e)=>{
    setBaseCurrency(e.target.value);
    setResult(0)
    let flag;
    if(e.target.value === 'UAH'){
        flag = { flag: Uah, symbol: '₴'}
        setFlagBase(flag)
    }
    else if(e.target.value === 'USD'){
         flag = { flag: Usd, symbol: '$'}
         setFlagBase(flag)
    }
    else if(e.target.value === 'EUR'){
         flag = { flag: Eur, symbol: '€'}
         setFlagBase(flag)
    }
    else if(e.target.value === 'GBP'){
        flag = { flag: Gbp, symbol: '£ '}
        setFlagBase(flag)
    }
    else if(e.target.value === 'PLN'){
        flag = { flag: Pln, symbol: 'zł'}
        setFlagBase(flag)
    }  
    
}
const getTargetCurrency = (e)=>{
    setResult(0)
    setTargetCurrency(e.target.value)
    let flag;
    if(e.target.value === 'UAH'){
        flag = { flag: Uah, symbol: '₴'}
        setFlagTarget(flag)
    }
    else if(e.target.value === 'USD'){
        flag = { flag: Usd, symbol: '$'}
         setFlagTarget(flag)
    }
    else if(e.target.value === 'EUR'){
        flag = { flag: Eur, symbol: '€'}
         setFlagTarget(flag)
    }
    else if(e.target.value === 'GBP'){
        flag = { flag: Gbp, symbol: '£ '}
        setFlagTarget(flag)
    }
    else if(e.target.value === 'PLN'){
        flag = { flag: Pln, symbol: 'zł'}
        setFlagTarget(flag)
    }  
}

const converter = ()=>{
    let rateBasic = currencies.filter(item => {
        if (item.cc === baseCurrency){
            return item 
        }})

    let rateTarget = currencies.filter(item => {
        if (item.cc === targetCurrency){
            return item 
        }})
    
        let result;
        if(baseCurrency=== 'UAH'){
             result = amount / rateTarget[0].rate
        }
        if(baseCurrency !== 'UAH' && targetCurrency !== 'UAH'){
             result = amount * rateBasic[0].rate / rateTarget[0].rate
        }
        if(targetCurrency === 'UAH' && baseCurrency !== 'UAH' ){
            result = amount * rateBasic[0].rate
       }

    setResult(result)
    
}

return(


<MainDeskContainer>
    <MainDeskWrapper>
        <form action="">
            
            <Flex alignItems='center' justifyContent='center' marginTop='20px' >
                <NbuLogoStyled src={NbuLogo} alt="NBU"/><TitleStyled>Non-cash currency converter</TitleStyled>
            </Flex>
            <CurrencyInput 
                    smallText="From:"
                    defaultValue={baseCurrency}
                    onChangeSelect={(e) =>{getBaseCurrency(e)}} 
                    flag={flagBase.flag} 
                    placeholder={'0.00'}
                    onChange={(e)=>{getAmount(e)}}   
                    marginTop='20px'
                    symb={flagBase.symbol} 
                    />
            <CurrencyInput 
                    smallText="To:" 
                    defaultValue={targetCurrency}
                    onChangeSelect={(e) =>{getTargetCurrency(e)}}
                    flag={flagTarget.flag} 
                    marginTop='20px' 
                    readOnly={true} 
                    value={result.toFixed(2)}  
                    symb={flagTarget.symbol}
                    />
            <Flex justifyContent='center'>
                <Button
                type='button'
                onClick={()=>{converter()}}
                children='EXCHANGE'
                padding='10px'
                color='#fff'
                borderRadius='20px'
                hoverBackgroundColor='#fff'
                fontSize='20x'
                border='2px solid #fff'
                backgroundColor='rgb(0,0,0,0)'
                margin='30px 0 30px 0'
                
                />
            </Flex>
        </form>
    </MainDeskWrapper>
</MainDeskContainer>
)

}

export default MainDesk;

